import { render, staticRenderFns } from "./RandChestionar.vue?vue&type=template&id=0a213f26&"
import script from "./RandChestionar.vue?vue&type=script&lang=js&"
export * from "./RandChestionar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports